import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import FiltersPanel from "../../../../../components/filter-panel/filter-panel";
import { Form } from "react-bootstrap";
import ArrowIconDisabled from "../../../../../assets/img/arrow-filter-solid-disabled.svg";
import ArrowIcon from "../../../../../assets/img/arrow-filter-solid.svg";
import FilterIcon from "../../../../../assets/icons/Icon - FilterDisabled.svg";
import FilterIconOn from "../../../../../assets/icons/Icon - Filter.svg";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  selectSelectedUsers,
  selectNumUsers,
  selectUsers,
} from "../../../../../redux/users/users-selector";
import { setSelectedUser } from "../../../../../redux/users/users-actions";
import { GetAllUsersNew } from "../../../../../../src/services/api/user-api";
import { selectUser } from "../../../../../redux/user/user-selector";
import "./users-table-header.styles.scss";

const tableHeaderInfo = [
  {
    name: "FULL NAME",
    filterNames: "Full Names",
    containerClassName: "th-fullname-col",
    hasFilter: true,
    hasSort: true,
    filterType: "UsersNew",
    sortBy: "name",
  },
  {
    name: "EMAIL ID",
    filterNames: "",
    containerClassName: "th-email-col",
    hasFilter: false,
    hasSort: true,
    filterType: "",
    sortBy: "email",
  },
  {
    name: "DEPARTMENT",
    filterNames: "Departments",
    containerClassName: "th-department-col",
    hasFilter: true,
    hasSort: true,
    filterType: "DepartmentsNew",
    sortBy: "department",
  },
  {
    name: "ROLE",
    filterNames: "Roles",
    containerClassName: "th-role-col",
    hasFilter: true,
    hasSort: true,
    filterType: "RolesNew",
    sortBy: "role",
  },
  {
    name: "STATUS",
    filterNames: "",
    containerClassName: "th-status-col",
    hasFilter: false,
    hasSort: true,
    filterType: "",
    sortBy: "status",
  },
  {
    name: "ACTIONS",
    filterNames: "",
    containerClassName: "th-admin-actions-col",
    hasFilter: false,
    hasSort: false,
    filterType: "",
    sortBy: "",
  },
];

const UsersTableHeaderNew = ({
  user: { privileges, profile },
  setSelectedUser,
  selectedUserIDS,
  users,
  changeData,
  refreshPage,
  setIsArchived,
  isArchived
}) => {
  const isSuperAdmin = profile?.isSuperAdminRole;
  const isSelfServe = window["APP_SETTINGS"].REACT_APP_SELFSERVE_USER === "TRUE";
  const [nonSelectableUsersCount, setNonSelectableUsersCount] = useState(0);
  const [allUsers, setAllUsers] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);
  const [allRoles, setAllRoles] = useState([]);
  const [activeFilterType, setActiveFilterType] = useState("");
  const [activeSortType, setActiveSortType] = useState("");
  const [isDescendingSort, setIsDescendingSort] = useState(false);
  const [selectedFilterRows, setSelectedFilterRows] = useState([]);

  const userListFetch = (usersList) => {
    let selectableUsersList = [];
    if (usersList?.length) {
      usersList.forEach(({ user }) => {
        let isCurrentUser = user?.Id === profile?.userID;
        let canBeArchived = privileges?.User?.Delete && !isCurrentUser;
        if (canBeArchived) selectableUsersList.push(user.Id);
      });
    }
    return selectableUsersList;
  };

  useEffect(() => {
    if (users)
      setNonSelectableUsersCount(users.length - userListFetch(users)?.length);
  }, [users]);

  const onSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedUser(userListFetch(users));
    } else {
      setSelectedUser([]);
    }
  };

  const getAllData = async () => {

    const searchQueryUsers = {
      PageNumber: 1,
      SortDesc: false,
      SortBy: "name",
      PageSize: 100000,
      Filters: [],
    };

    const totalUsers = await GetAllUsersNew(searchQueryUsers);
    totalUsers && setAllUsers(totalUsers.Users);

    let departments = totalUsers.Users.map((user) => {
      return { Id: user.CompanyId, Name: user.CompanyName };
    })
    let uniqueDepartments = Object.values(
      departments.reduce((acc, obj) => ({ ...acc, [obj.Id]: obj }), {})
    );
    uniqueDepartments =
      isSelfServe && !isSuperAdmin
        ? uniqueDepartments.filter((department) => {
            return department.Name === profile.CompanyName;
          })
        : uniqueDepartments;
    setAllDepartments(uniqueDepartments);

    let roles = totalUsers.Users.map((user) => {
      return { roleID: user.RoleId, roleName: user.StrRole };
    })
    let uniqueRoles = Object.values(
      roles.reduce((acc, obj) => ({ ...acc, [obj.roleID]: obj }), {})
    );
    setAllRoles(uniqueRoles);
  };

  useEffect(() => {
    getAllData();
  }, []);

 useEffect(() => {
  if (isArchived) {
    const fetchAndUpdateUsers = async () => {
      try {
        const searchQueryUsers = {
          PageNumber: 1,
          SortDesc: false,
          SortBy: "name",
          PageSize: 100000,
          Filters: [],
        };

        const totalUsers = await GetAllUsersNew(searchQueryUsers);
        if (totalUsers) {
          const newUsersList = totalUsers.Users;
          if (users.length !== newUsersList.length) {
            setAllUsers(newUsersList);
            const updatedFilterRows = selectedFilterRows.filter(row => 
              isRowInUpdatedUsersList(row, newUsersList)
            );
            setSelectedFilterRows(updatedFilterRows);
            if (updatedFilterRows.length === 0) {
              setActiveFilterType("");
            }
          }
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setIsArchived(false);
      }
    };
    fetchAndUpdateUsers();
  }
}, [isArchived, users, selectedUserIDS, setSelectedUser, setIsArchived, selectedFilterRows]);
  
const isRowInUpdatedUsersList = (row, newUsersList) => {
  return newUsersList.some(user => user && user.Id === row.Id);
};
  const passPayload = (label) => {
    switch (label) {
      case "FULL NAME":
        return allUsers;
      case "DEPARTMENT":
        return allDepartments;
      case "ROLE":
        return allRoles;
      default:
        return [];
    }
  };

  const updateFilter = (selectedRows, type) => {
    setSelectedFilterRows(selectedRows);
    setActiveFilterType(type);
  };

  const clearFilter = () => {
    setActiveFilterType("");
    setSelectedFilterRows([]);
    refreshPage();
  };

  const saveFilter = (newFilter) => {
    changeData(newFilter);
  };

  const handleSortClick = (sortType) => {
    if (activeSortType === sortType && !isDescendingSort) {
      setActiveSortType("");
      setIsDescendingSort(false);
      changeData(undefined, "name", false);
      return;
    }

    if (activeSortType !== sortType) {
      setActiveSortType(sortType);
      setIsDescendingSort(true);
      changeData(undefined, sortType, true);
      return;
    }

    setIsDescendingSort(false);
    changeData(undefined, sortType, false);
  };

  return (
    <thead className="admin-table-header">
      <tr>
        <th className="th-checkbox-col">
          <Form.Check
            type={"checkbox"}
            disabled={!privileges["User"].Delete}
            onClick={(e) => onSelectAll(e)}
            checked={
              users?.length !== 0 &&
              selectedUserIDS.length &&
              selectedUserIDS.length === users.length - nonSelectableUsersCount
            }
          />
        </th>
        {tableHeaderInfo.map((labelInfo, index) => {
          return (
            <th className={labelInfo.containerClassName} key={index}>
              <div className={`th-container`}>
                {labelInfo.hasFilter && (
                  <div className="th-icon-filter">
                    <FiltersPanel
                      selected={
                        activeFilterType === labelInfo.filterType
                          ? selectedFilterRows
                          : []
                      }
                      filterIcon={
                        activeFilterType === labelInfo.filterType
                          ? FilterIconOn
                          : FilterIcon
                      }
                      header={labelInfo.filterNames}
                      type={labelInfo.filterType}
                      updateSelected={updateFilter}
                      save={saveFilter}
                      clear={clearFilter}
                      change={() => {}}
                      close={() => {}}
                      adminPayload={passPayload(labelInfo.name)}
                    ></FiltersPanel>
                  </div>
                )}
                <div className="th-name">{labelInfo.name}</div>
                {labelInfo.hasSort && (
                  <div className="arrow-holder">
                    <img
                      className="th-icon-up"
                      src={
                        activeSortType === labelInfo.sortBy && !isDescendingSort
                          ? ArrowIcon
                          : ArrowIconDisabled
                      }
                      alt="filter-arrow"
                      onClick={() => handleSortClick(labelInfo.sortBy)}
                    />
                    <img
                      className="th-icon-down"
                      src={
                        activeSortType === labelInfo.sortBy && isDescendingSort
                          ? ArrowIcon
                          : ArrowIconDisabled
                      }
                      alt="filter-arrow"
                      onClick={() => handleSortClick(labelInfo.sortBy)}
                    />
                  </div>
                )}
              </div>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

const mapState = createStructuredSelector({
  user: selectUser,
  users: selectUsers,
  selectedUserIDS: selectSelectedUsers,
  numUsers: selectNumUsers,
});

const mapDispatch = (dispatch) => ({
  setSelectedUser: (idList) => dispatch(setSelectedUser(idList)),
});

UsersTableHeaderNew.propTypes = {
  user: PropTypes.object.isRequired,
  setSelectedUser: PropTypes.func.isRequired,
  selectedUserIDS: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
  changeData: PropTypes.func.isRequired,
  refreshPage: PropTypes.func.isRequired,
  isArchived: PropTypes.bool.isRequired,
  setIsArchived: PropTypes.func.isRequired,
};
export default connect(mapState, mapDispatch)(UsersTableHeaderNew);
